import { render, staticRenderFns } from "./Doghnut.vue?vue&type=template&id=499fa1d8"
import script from "./Doghnut.vue?vue&type=script&lang=js"
export * from "./Doghnut.vue?vue&type=script&lang=js"
import style0 from "./Doghnut.vue?vue&type=style&index=0&id=499fa1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports